import React, { useEffect, useState } from "react";
import { requestCanceller } from "../../service/axiosCancelToken";
import { authToken } from "../../service/userService";
import MainContext from "./../../context/mainContext";
import socket from "../../service/socket";
import ReloadAppModal from "../shared/ReloadAppModal";
import ConfirmRegisterModal from './../shared/ConfirmRegisterModal';
import toast from "react-hot-toast";
import { addDays } from "../../util/dateTime";
import { useLocation, useNavigate } from "react-router-dom";

const GlobalState = props => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const showLogin = () => setShowLoginModal(true);
    const hideLogin = () => setShowLoginModal(false);
    const [showReloadAppModal, setShowReloadAppModal] = useState(false);
    const [reloadPage, setReloadPage] = useState(false);
    const { pathname } = useLocation();
    const [factureInfo, setFactureInfo] = useState(() => {
        let info = '';
        if (localStorage.getItem('info')) {
            info = localStorage.getItem('info');
        }
        return info;
    });
    const [loggedIn, setLoggedIn] = useState();
    const login = (user) => setLoggedIn(user);
    const logout = () => setLoggedIn();

    const [shoppingCart, setShoppingCart] = useState(() => {
        let items = [];
        try {
            if (localStorage.getItem('shoppingCart') &&
                Array.isArray(JSON.parse(localStorage.getItem('shoppingCart'))) &&
                localStorage.getItem('shoppingCartExp') &&
                Number(new Date()) < Number(new Date(localStorage.getItem('shoppingCartExp')))
            ) {
                items = [...JSON.parse(localStorage.getItem('shoppingCart'))];

            }
            else {
                localStorage.setItem('shoppingCart', []);
            }
        } catch (err) {
            toast.error('local storage error !')
        }

        return items;
    });

    const addToShoppingCart = (newItem) => setShoppingCart(prev => {
        const allItems = [...prev];
        let index = allItems.findIndex(item => item._id === newItem._id);
        try {
            if (index < 0) {
                allItems.push(newItem);
            }
            else {
                allItems[index].count = newItem.count;
            }
        } catch (error) {

        }

        try {
            const expireDate = addDays(Date.now(), 2).timeStamp;
            localStorage.setItem('shoppingCart', JSON.stringify(allItems));
            localStorage.setItem('shoppingCartExp', new Date(expireDate));
        } catch (err) {
            toast.error('local storage error !')
        }

        return allItems;
    });
    const removeFromShoppingCart = (removingItem) => setShoppingCart(prev => {

        let allItems = [...prev];
        let index = allItems.findIndex(item => item._id === removingItem._id);
        let newItems = [];
        try {
            if (removingItem.count >= 1) {
                allItems[index].count = removingItem.count;
                newItems = allItems;
            }
            else {
                newItems = allItems.filter(item => item._id !== removingItem._id);
            }
        } catch (error) {

        }

        try {
            const expireDate = addDays(Date.now(), 2).timeStamp;
            localStorage.setItem('shoppingCart', JSON.stringify(newItems));
            localStorage.setItem('shoppingCartExp', new Date(expireDate));
        } catch (err) {
            toast.error('local storage error !')
        }

        return newItems;
    });
    const clearShoppingCart = () => {
        setShoppingCart([])
        setFactureInfo('')
        localStorage.removeItem('shoppingCart')
        localStorage.removeItem('shoppingCartExp')
        localStorage.setItem('info', '')
    };

    const cancelRequest = requestCanceller();
    const navigate = useNavigate();

    const authorization = async () => {
        try {
            if (localStorage.getItem('token')) {
                const { status, data } = await authToken({ signal: cancelRequest.signal });
                if (status === 201) {
                    setLoggedIn(data.user);
                }
            }


        } catch (err) {
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('token');
                return navigate('/', { replace: true })
            }
        }

    }

    useEffect(() => {
        authorization();

        socket.on('application', data => {
            if (data.action === 'reload') {
                authorization('Reload');
                setReloadPage(true);
                setTimeout(() => {
                    setReloadPage(false);
                }, 50);
            }
        })

        return () => {
            cancelRequest.cancel();
            socket.off('application');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        socket.on('disconnect', () => {
            if (loggedIn && loggedIn.isAdmin && pathname.includes('/dashboard')) {
                setShowReloadAppModal(true);
            }
        })

        return () => {
            socket.off('disconnect');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedIn, pathname])

    const [showConfirmRegisterModal, setShowConfirmRegisterModal] = useState(false);


    useEffect(() => {
        if (loggedIn && loggedIn.status === 'Disable' && loggedIn.firstTime) {
            setShowConfirmRegisterModal(true)
        }
        socket.on('userStatus', (data) => {
            if (data.action === 'update-status' && loggedIn && (loggedIn._id === data.userId)) {
                login({ ...loggedIn, status: data.newStatus })
            }
        })
        return () => {
            socket.off('userStatus');
        }
    }, [loggedIn])

    return (
        <MainContext.Provider
            value={{
                showLoginModal: showLoginModal,
                showLogin: showLogin,
                hideLogin: hideLogin,
                loggedIn: loggedIn,
                login: login,
                logout: logout,
                shoppingCart: shoppingCart,
                addToShoppingCart: addToShoppingCart,
                removeFromShoppingCart: removeFromShoppingCart,
                clearShoppingCart: clearShoppingCart,
                factureInfo: factureInfo,
                setFactureInfo: setFactureInfo
            }}
        >

            {!reloadPage && props.children}
            <ReloadAppModal
                show={showReloadAppModal}
                handleClose={() => {
                    setShowReloadAppModal(false);
                }}
                onConfirm={() => {
                    authorization('Reload');
                    setShowReloadAppModal(false);
                    setReloadPage(true);
                    setTimeout(() => {
                        setReloadPage(false);
                    }, 50);
                }}
            />
            <ConfirmRegisterModal
                message={`ثبت نام شما انجام شده ، برای مشاهده قیمت ها و ثبت سفارش ، باید عضویت شما تأیید شود. 
                    لطفا منتظر تأیید عضویت باشید و یا جهت تأیید سریع تر میتوانید با شماره 
                    05132425575 تماس بگیرید`}
                show={showConfirmRegisterModal}
                onConfirm={() => setShowConfirmRegisterModal(false)}
                handleClose={() => setShowConfirmRegisterModal(false)}
            />
        </MainContext.Provider>
    );
};

export default GlobalState;
